// extracted by mini-css-extract-plugin
export var carouselArrowLeft = "carousel-transformer-module--carousel-arrow-left--0ae86";
export var carouselArrowRight = "carousel-transformer-module--carousel-arrow-right--aa3d5";
export var carouselImage = "carousel-transformer-module--carousel-image--c6bc6";
export var carouselTransformer = "carousel-transformer-module--carousel-transformer--86930";
export var modalButton = "carousel-transformer-module--modal-button--6178e";
export var modalImage = "carousel-transformer-module--modal-image--d99fb";